import React from "react"

const ChinhSachBaoVeNguoiDung = () => {
  return (
    <>
      <p>
        <strong>CHÍNH SÁCH BẢO VỆ QUYỀN LỢI NGƯỜI TIÊU DÙNG DỄ BỊ TỔN THƯƠNG</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>
        <strong>1. Mục đích</strong>
      </p>

      <p>
        Chính sách bảo vệ quyền lợi của người tiêu dùng dễ bị tổn thương này được ban hành nhằm bảo đảm quyền và lợi ích
        hợp pháp của người tiêu dùng dễ bị tổn thương trong quá trình sử dụng ON Live TV; xây dựng cơ chế hỗ trợ, tiếp
        nhận và giải quyết phản ánh, yêu cầu, khiếu nại, tranh chấp phù hợp với từng nhóm người tiêu dùng dễ bị tổn
        thương theo quy định của pháp luật.
      </p>

      <p>
        <strong>2. Phạm vi và đối tượng áp dụng</strong>
      </p>

      <p>Chính sách này áp dụng đối với:</p>

      <p>(1) Khách hàng sử dụng dịch vụ ON Live TV là người tiêu dùng dễ bị tổn thương.</p>

      <p>
        Trong đó, người tiêu dùng dễ bị tổn thương là người tiêu dùng có khả năng chịu nhiều tác động bất lợi về tiếp
        cận thông tin, sức khỏe, tài sản, giải quyết tranh chấp tại thời điểm mua hoặc sử dụng sản phẩm, hàng hóa, dịch
        vụ, bao gồm:
      </p>

      <p>- Người cao tuổi theo quy định của pháp luật về người cao tuổi;</p>

      <p>- Người khuyết tật theo quy định của pháp luật về người khuyết tật;</p>

      <p>- Trẻ em theo quy định của pháp luật về trẻ em;</p>

      <p>
        - Người dân tộc thiểu số; người sinh sống tại vùng đồng bào dân tộc thiểu số và miền núi, hải đảo, vùng có điều
        kiện kinh tế - xã hội khó khăn, vùng có điều kiện kinh tế - xã hội đặc biệt khó khăn theo quy định của pháp
        luật;
      </p>

      <p>- Phụ nữ đang mang thai hoặc nuôi con dưới 36 tháng tuổi;</p>

      <p>- Người bị bệnh hiểm nghèo theo quy định của pháp luật;</p>

      <p>- Thành viên hộ nghèo theo quy định của pháp luật.</p>

      <p>
        (2) Việc tiếp nhận, hỗ trợ và giải quyết phản ánh, yêu cầu, khiếu nại của người tiêu dùng dễ bị tổn thương liên
        quan đến dịch vụ.
      </p>

      <p>
        <strong>
          3. Nguyên tắc tiếp nhận, hỗ trợ và giải quyết phản ánh, yêu cầu, khiếu nại của người tiêu dùng dễ bị tổn
          thương
        </strong>
      </p>

      <p>
        <strong>3.1. Nguyên tắc tiếp nhận</strong>
      </p>

      <p>
        - Tôn trọng, bảo đảm quyền và lợi ích hợp pháp của người tiêu dùng dễ bị tổn thương theo quy định của pháp luật.
      </p>

      <p>
        - Không phân biệt đối xử, kỳ thị hoặc lợi dụng hoàn cảnh, tình trạng của người tiêu dùng dễ bị tổn thương để xâm
        phạm quyền và lợi ích hợp pháp của họ.
      </p>

      <p>
        - Ưu tiên tiếp nhận, xem xét và xử lý các phản ánh, yêu cầu, khiếu nại của người tiêu dùng dễ bị tổn thương.
      </p>

      <p>
        - Bảo đảm thông tin cung cấp cho người tiêu dùng dễ bị tổn thương được thể hiện rõ ràng, dễ tiếp cận và dễ hiểu.
      </p>

      <p>
        - Phải ưu tiên tiếp nhận, xử lý và không chuyển yêu cầu của người tiêu dùng cho bên thứ ba giải quyết, trừ
        trường hợp bên thứ ba đó có nghĩa vụ liên quan. Trường hợp từ chối giải quyết yêu cầu, Công ty phải trả lời bằng
        văn bản, trong đó nêu rõ căn cứ pháp lý và sự không phù hợp với nội dung chính sách đã công bố.
      </p>

      <p>
        <strong>
          3.2. Quá trình tiếp nhận, hỗ trợ, giải quyết cần đảm bảo các quyền lợi sau của người tiêu dùng dễ bị tổn
          thương:
        </strong>
      </p>

      <p>
        - Được ưu tiên tiếp nhận và xử lý các yêu cầu hỗ trợ, phản ánh, khiếu nại, yêu cầu thương lượng và giải quyết
        tranh chấp theo Chính sách này;
      </p>

      <p>
        - Được cung cấp đầy đủ, chính xác, minh bạch các thông tin về ON Live TV, gói dịch vụ, giá dịch vụ, phương thức
        thanh toán, điều kiện giao dịch, quyền và nghĩa vụ của khách hàng trước khi thực hiện giao dịch;
      </p>

      <p>
        - Được hỗ trợ tra cứu thông tin tài khoản, gói dịch vụ đã đăng ký, lịch sử giao dịch, thời hạn sử dụng dịch vụ
        và các quyền lợi liên quan đến ON Live TV;
      </p>

      <p>
        - Được hỗ trợ giải thích về việc đăng ký, gia hạn, hủy gói dịch vụ, thanh toán, hoàn tiền, truy cập nội dung và
        các vấn đề phát sinh trong quá trình sử dụng ON Live TV;
      </p>

      <p>
        - Được áp dụng cơ chế tiếp nhận, giải quyết phản ánh, yêu cầu, khiếu nại và tranh chấp theo quy định của pháp
        luật và quy trình giải quyết khiếu nại của ON Live TV;
      </p>

      <p>
        - Không bị phân biệt đối xử hoặc bị lợi dụng hoàn cảnh dễ bị tổn thương để ảnh hưởng đến quyền và lợi ích hợp
        pháp của mình;
      </p>

      <p>
        - Trường hợp người tiêu dùng dễ bị tổn thương gặp khó khăn trong việc tiếp cận, đọc, hiểu hoặc cung cấp thông
        tin, Công ty có thể hỗ trợ giải thích bằng lời nói, hình ảnh hoặc làm việc thông qua người đại diện hợp pháp,
        người giám hộ hoặc người hỗ trợ theo quy định của pháp luật.
      </p>

      <p>
        <strong>4. Biện pháp hỗ trợ đối với từng nhóm người tiêu dùng dễ bị tổn thương</strong>
      </p>

      <p>
        <strong>4.1. Người cao tuổi:</strong>
      </p>

      <p>
        - Cung cấp thông tin về dịch vụ, giá dịch vụ, điều kiện sử dụng và phương thức thanh toán bằng ngôn ngữ rõ ràng,
        dễ hiểu;
      </p>

      <p>- Ưu tiên tiếp nhận và xử lý các yêu cầu hỗ trợ, phản ánh, khiếu nại;</p>

      <p>
        - Hỗ trợ giải thích các vấn đề liên quan đến đăng ký tài khoản, đăng nhập, thanh toán, đăng ký hoặc hủy gói dịch
        vụ thông qua các kênh chăm sóc khách hàng của Công ty.
      </p>

      <p>- Tăng cường hỗ trợ thông qua các kênh chăm sóc khách hàng.</p>

      <p>
        <strong>4.2. Người khuyết tật:</strong>
      </p>

      <p>
        - Tạo điều kiện để người tiêu dùng tiếp cận thông tin, gửi yêu cầu hỗ trợ, phản ánh hoặc khiếu nại thông qua các
        kênh phù hợp;
      </p>

      <p>- Chấp nhận làm việc thông qua người đại diện hợp pháp hoặc người hỗ trợ theo quy định của pháp luật;</p>

      <p>
        - Linh hoạt trong phương thức trao đổi, xác minh và tiếp nhận thông tin phù hợp với tình trạng của người tiêu
        dùng.
      </p>

      <p>
        <strong>4.3. Trẻ em:</strong>
      </p>

      <p>- Thực hiện các biện pháp phù hợp nhằm bảo vệ quyền và lợi ích hợp pháp của trẻ em khi sử dụng dịch vụ;</p>

      <p>
        - Việc xác nhận, xử lý các yêu cầu liên quan đến tài khoản, giao dịch hoặc khiếu nại được thực hiện thông qua
        cha, mẹ hoặc người đại diện hợp pháp theo quy định của pháp luật.
      </p>

      <p>
        <strong>
          4.4. Người dân tộc thiểu số; người sinh sống tại vùng đồng bào dân tộc thiểu số và miền núi, hải đảo, vùng có
          điều kiện kinh tế - xã hội khó khăn, vùng có điều kiện kinh tế - xã hội đặc biệt khó khăn theo quy định của
          pháp luật:
        </strong>
      </p>

      <p>
        - Cung cấp thông tin về dịch vụ, giao dịch và quyền lợi người tiêu dùng bằng ngôn ngữ rõ ràng, dễ hiểu, không
        được từ chối giải quyết yêu cầu vì lý do khác biệt về tiếng nói, chữ viết, phong tục, tập quán;
      </p>

      <p>
        - Hỗ trợ tiếp nhận và xử lý yêu cầu thông qua các kênh trực tuyến, điện thoại hoặc email do Công ty công bố;
      </p>

      <p>
        - Tạo điều kiện thuận lợi để người tiêu dùng tiếp cận các thông tin về chính sách, điều khoản sử dụng, giá dịch
        vụ và cơ chế giải quyết khiếu nại.
      </p>

      <p>
        <strong>4.5. Phụ nữ mang thai hoặc nuôi con dưới 36 tháng tuổi:</strong>
      </p>

      <p>- Ưu tiên tiếp nhận và xử lý các yêu cầu hỗ trợ, phản ánh, khiếu nại;</p>

      <p>
        - Tạo điều kiện thuận lợi trong việc trao đổi, xác minh thông tin và giải quyết yêu cầu thông qua các kênh trực
        tuyến của Công ty.
      </p>

      <p>
        <strong>4.6. Người bị bệnh hiểm nghèo theo quy định của pháp luật:</strong>
      </p>

      <p>
        - Ưu tiên tiếp nhận và xử lý phản ánh, yêu cầu, khiếu nại trong thời gian sớm nhất phù hợp với tính chất vụ
        việc;
      </p>

      <p>
        - Linh hoạt trong việc tiếp nhận hồ sơ, tài liệu và phương thức trao đổi để giảm thiểu khó khăn cho người tiêu
        dùng.
      </p>

      <p>
        <strong>4.7. Thành viên hộ nghèo theo quy định pháp luật:</strong>
      </p>

      <p>
        - Hỗ trợ cung cấp đầy đủ thông tin về dịch vụ, giá dịch vụ, phương thức thanh toán, điều kiện giao dịch và các
        quyền lợi của khách hàng trước khi thực hiện giao dịch;
      </p>

      <p>
        - Ưu tiên hỗ trợ giải thích các điều khoản sử dụng dịch vụ, chi phí dịch vụ và quyền lợi của khách hàng cách rõ
        ràng, dễ hiểu;
      </p>

      <p>
        - Ưu tiên tiếp nhận, giải quyết các phản ánh, yêu cầu, khiếu nại liên quan đến giao dịch, thanh toán hoặc việc
        sử dụng ON Live TV.
      </p>

      <p>
        <strong>5. Quy trình tiếp nhận và giải quyết phản ánh, khiếu nại của người tiêu dùng dễ bị tổn thương</strong>
      </p>

      <p>
        <strong>Bước 1. Tiếp nhận yêu cầu</strong>
      </p>

      <p>
        Người tiêu dùng dễ bị tổn thương hoặc người đại diện hợp pháp của người tiêu dùng có quyền gửi phản ánh, yêu
        cầu, khiếu nại, yêu cầu thương lượng hoặc yêu cầu bảo vệ quyền lợi thông qua các kênh tiếp nhận do VTVlive công
        bố:
      </p>

      <p>
        <strong>Công ty Cổ phần Truyền hình Tương tác Việt Nam</strong>
      </p>

      <p>- Trụ sở chính: Số 3 Ngõ 84 Ngọc Khánh, phường Giảng Võ, Thành phố Hà Nội</p>

      <p>- Hotline: 1900.866.666 (miễn phí)</p>

      <p>
        - Email: <a href="mailto:hotro@onlive.vn">hotro@onlive.vn</a>
      </p>

      <p>
        Trường hợp người tiêu dùng dễ bị tổn thương gặp khó khăn trong việc gửi yêu cầu bằng văn bản hoặc sử dụng các
        phương tiện điện tử, Công ty hỗ trợ tiếp nhận thông tin thông qua điện thoại, thư điện tử hoặc thông qua người
        đại diện theo quy định của pháp luật.
      </p>

      <p>
        <strong>Bước 2. Xác định đối tượng người tiêu dùng dễ bị tổn thương</strong>
      </p>

      <p>
        Trong vòng 24 - 48 giờ kể từ khi tiếp nhận yêu cầu, Công ty căn cứ vào thông tin do khách hàng cung cấp, thông
        tin từ người đại diện hợp pháp, tài liệu chứng minh (nếu có) hoặc các căn cứ hợp lý khác để xác định khách hàng
        thuộc nhóm người tiêu dùng dễ bị tổn thương nhằm áp dụng cơ chế hỗ trợ phù hợp theo Chính sách này. Trường hợp
        cần thiết, Công ty có thể đề nghị khách hàng hoặc người đại diện hợp pháp cung cấp thêm thông tin hoặc tài liệu
        cần thiết để phục vụ việc xác minh.
      </p>

      <p>
        <strong>Bước 3. Áp dụng cơ chế hỗ trợ theo Chính sách</strong>
      </p>

      <p>
        Sau khi xác định khách hàng thuộc nhóm người tiêu dùng dễ bị tổn thương, Công ty áp dụng cơ chế ưu tiên tiếp
        nhận, hỗ trợ và xử lý yêu cầu phù hợp với từng nhóm đối tượng theo quy định tại Điều 4 của Chính sách này. Trong
        quá trình giải quyết vụ việc, Công ty ưu tiên sử dụng ngôn ngữ rõ ràng, dễ hiểu; hỗ trợ giải thích các thông tin
        liên quan đến dịch vụ, giao dịch, quyền lợi của khách hàng và phương án xử lý để khách hàng có thể tiếp cận và
        thực hiện đầy đủ các quyền của mình.
      </p>

      <p>
        <strong>Bước 4. Giải quyết yêu cầu</strong>
      </p>

      <p>
        Việc tiếp nhận, giải quyết phản ánh, yêu cầu, khiếu nại, yêu cầu thương lượng và tranh chấp của người tiêu dùng
        dễ bị tổn thương được thực hiện theo Quy trình tiếp nhận và Giải quyết khiếu nại. Trong quá trình giải quyết,
        Công ty ưu tiên áp dụng các biện pháp hỗ trợ phù hợp với từng nhóm người tiêu dùng dễ bị tổn thương nhằm bảo đảm
        khả năng tiếp cận thông tin, thực hiện quyền khiếu nại, yêu cầu thương lượng, giải quyết tranh chấp và các quyền
        khác theo quy định của pháp luật.
      </p>

      <p>
        <strong>Bước 5. Thông báo kết quả giải quyết</strong>
      </p>

      <p>
        Kết quả giải quyết được Công ty thông báo cho người tiêu dùng dễ bị tổn thương hoặc người đại diện hợp pháp
        thông qua phương thức liên hệ mà khách hàng đã cung cấp hoặc phương thức khác do các bên thống nhất. Trường hợp
        khách hàng không đồng ý với kết quả giải quyết, khách hàng có quyền tiếp tục yêu cầu thương lượng, hòa giải hoặc
        thực hiện các quyền khác theo quy định của pháp luật.
      </p>

      <p>
        <strong>6. Bảo mật thông tin</strong>
      </p>

      <p>
        - Công ty có trách nhiệm bảo mật thông tin của người tiêu dùng dễ bị tổn thương theo quy định của pháp luật và
        các chính sách áp dụng của Công ty.
      </p>

      <p>
        - Thông tin được cung cấp trong quá trình hỗ trợ, giải quyết phản ánh, khiếu nại hoặc tranh chấp chỉ được sử
        dụng cho mục đích giải quyết vụ việc hoặc các mục đích khác theo quy định của pháp luật.
      </p>

      <p>
        <strong>7. Điều khoản chung</strong>
      </p>

      <p>
        7.1. Công ty Cổ phần Truyền hình Tương tác Việt Nam cam kết tuân thủ đầy đủ các quy định của pháp luật về bảo vệ
        quyền lợi người tiêu dùng, bao gồm các quy định liên quan đến người tiêu dùng dễ bị tổn thương; đồng thời triển
        khai các biện pháp phù hợp nhằm bảo đảm quyền và lợi ích hợp pháp của người tiêu dùng dễ bị tổn thương trong quá
        trình sử dụng Dịch vụ ON Live TV.
      </p>

      <p>
        7.2. Cập nhật, thay đổi: Trường hợp có sự thay đổi của quy định pháp luật hoặc Công ty điều chỉnh nội dung Chính
        sách này, Công ty sẽ công bố công khai phiên bản cập nhật trên Website của ON Live TV trước thời điểm áp dụng.
      </p>

      <p>
        7.3. Trường hợp có sự khác nhau giữa nội dung Chính sách này và quy định của pháp luật thì áp dụng quy định của
        pháp luật hiện hành.
      </p>
    </>
  )
}

export default ChinhSachBaoVeNguoiDung
